/* eslint-disable no-nested-ternary,no-useless-escape */

import { Message } from 'types'
import convertToHTML from 'utils/convertToHTML'
import addScheme from 'utils/addScheme'

const getMessageHTML = (message: Message, maxLength?: number): string => {
	const messageContent =
		message.type === 'TEXT'
			? message.message || ''
			: message.type === 'MEDIA_IMAGE'
			? message.image?.caption || ''
			: message.type === 'MEDIA_VIDEO'
			? message.video?.caption || ''
			: message.type === 'MEDIA_DOCUMENT'
			? message.document?.caption || ''
			: ''

	const trimmedMessageContent =
		messageContent && maxLength && messageContent.length > maxLength
			? `${messageContent.substring(0, maxLength)}...`
			: messageContent

	return message.type !== 'MEDIA_DOCUMENT'
		? convertToHTML(trimmedMessageContent).replace(
				/((?:(?:http?|ftp)s*:\/\/)?[a-z0-9-%\/\&=?\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?)/gi,
				x => `<a href="${addScheme(x)}" target="_blank" rel="noreferrer">${x}</a>`
		  )
		: trimmedMessageContent
}

export default getMessageHTML
